import styled from 'styled-components';

export const ModalContainer = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    margin-top: 20px;
    font-size: 2rem;
    color: ${({ theme }) => theme.purple};
  }

  img {
    width: 200px;
    height: 200px;
    margin-bottom: 12px;
  }

  span {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 26px;

    p {
      font-size: 1.5rem;
      margin: 0;

      &:last-child {
        font-weight: 600;
      }
    }
  }
`;

export const ContainerFooter = styled.footer`
  display: flex;

  button {
    border: 0;
    height: 50px;
    width: 50%;
    font-size: 1.5rem;
    letter-spacing: 1.5px;

    &:first-child {
      background: ${({ theme }) => theme.purple};

      &:hover:disabled {
        background: ${({ theme }) => theme.purple};
        color: #fff;
      }
    }

    &:last-child {
      background: ${({ theme }) => theme.green};

      &:hover:disabled {
        background: ${({ theme }) => theme.green};
        color: #fff;
      }
    }

    &:hover:not(:disabled) {
      filter: brightness(0.9);
    }

    &:disabled {
      color: #fff;
    }
  }
`;
